var AbstractTypes = /** @class */ (function () {
    function AbstractTypes() {
    }
    AbstractTypes.prototype.renderInput = function (rule) {
    };
    AbstractTypes.prototype.transformRuleOperator = function (rule) {
    };
    AbstractTypes.prototype.ruleDisplayValue = function (value, rule) {
        return value;
    };
    AbstractTypes.prototype.transformFilter = function (filter) {
        return filter;
    };
    return AbstractTypes;
}());
export default AbstractTypes;
